import React, {useEffect, useState} from 'react';
import Pagination from 'react-js-pagination';
import moment from 'moment';
import './EventList.scss';

global.eventListLoadedFonts = [];

export default function EventList(props) {
  const [activePage, setActivePage] = useState(0);
  const calendar = FW.store.get('section-' + props.section.get('id')) || FW.Models.Calendar.findOrCreate({id: props.section.prop('calendar_id')});
  const events = calendar.get('event_instances');
  events._includedRelations = ['event', 'featured_image'];

  const loadFonts = () => {
    let families = [];
    const familyMatcher = /font-family:[ "']*([^;"',]+)/g;
    let uniqueFamilies = [];
    events.forEach((event) => {
      const e = event.get('event');
      let match = familyMatcher.exec(e.get('description'));
      while (match) {
        if (match[1]) families.push(match[1]);
        match = familyMatcher.exec(e.get('description'));
      }
      $.each(families, function(i, el) {
        if ($.inArray(el, uniqueFamilies) === -1) uniqueFamilies.push(el);
      });
    });

    uniqueFamilies.forEach(fontName => {
      if (fontName) {
        if (!global.eventListLoadedFonts.includes(fontName)) {
          if (window.WebFont) {
            window.WebFont.load({
              google: {
                families: [fontName]
              }
            });
            global.eventListLoadedFonts.push(fontName);
          }
        }
      }
    });
  };

  useEffect(() => {
    calendar.ensureLoaded().then(() => {
      events.addQuery({
        end_time: moment().format('YYYY-MM-DD') + '|' + moment().add(10, 'y').format('YYYY-MM-DD')
      });
      events.setPageSize(props.section.prop('page_size') || 5, () => {
        setActivePage(1);
        loadFonts();
      });
    });
  }, [props.section.prop('page_size'), props.reboot]);

  const handlePageChange = (v) => {
    events.getPage(v, () => {
      setActivePage(v);
      loadFonts();
    });
  }

  useEffect(() => {
    let section = props.section;
    section._editButtons = [{
      title: 'Edit Events',
      class: 'glyphicon-pencil',
      type: 'btn-default',
      action: () => {
        window.parent.FW.editor.setMode('editCalendar', 'editCalendar', {
          calendar: calendar,
          section: props.section,
          remount: true
        });
      }
    }];
  }, []);

  return <div className="event-list-section">
    {events.map((instance) => {
      const e = instance.get('event');
      const image = instance.get('featured_image');
      return <div className="event-item" key={instance.get('id')}>
        {props.section.prop('hide_thumbnail') ? null : <div className="event-image">
          <img src={(image && image !== null && image.helper ? image.helper.featuredUrl(800) : '')} />
        </div>}
        <div className="event-content">
          <span className="event-title">{e.get('title')}</span>
          <span className="event-date">{instance.displayDate}</span>
          <div dangerouslySetInnerHTML={{__html: e.get('description')}} />
        </div>
      </div>;
    })}
    <div style={{width: '100%', textAlign: 'center'}}>
      <Pagination
        activePage={activePage}
        itemsCountPerPage={events.pagination.size}
        totalItemsCount={events.pagination.total}
        pageRangeDisplayed={props.section.prop('pages_to_show') ?? 13}
        onChange={handlePageChange}
      />
    </div>
  </div>
}
